import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private confirmDialogSubject = new Subject<any>();
  confirmDialog$ = this.confirmDialogSubject.asObservable();

  private toastSubject = new Subject<any>();
  toast$ = this.toastSubject.asObservable();

  
  smartMessageBox(data: { title: string; content: string }, callback: (buttonPressed: string) => void) {
    this.confirmDialogSubject.next({ ...data, callback });
  }

  smallBox(data: { title: string; content: string; icon?: string; number?: string; timeout?: number ; color?: string; sound_file?: string;  }) {
    this.toastSubject.next(data);
  }

}
